// extracted by mini-css-extract-plugin
module.exports = {"eventsLayoutBackground":"Events_eventsLayoutBackground__3CXgo","events-content":"Events_events-content__3puST","logoPreview":"Events_logoPreview__1JqdM"};